module.exports = __webpack_public_path__ + "img/Notes.b5e5fc75.png";